import { useState, useEffect } from 'react'

interface ConnectivityState {
  isOnline: boolean
  showBanner: boolean
  showFullscreen: boolean
}

export function useConnectivity(hasAnyData: boolean): ConnectivityState {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return {
    isOnline,
    showBanner: !isOnline && hasAnyData,
    showFullscreen: !isOnline && !hasAnyData,
  }
}
